/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){console.log('replaceUrlParam');var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};




/*
  waf functions
*/


init = () => {

  // General
  getHash();

  // Headers
  hideAnnouncement();
  swapHeaderItems();
  mobileDropdowns();

  // Interface elements
  toggleAccordion();

  // Slider
  stageSlider();
  thumbSlider();
  responsiveSlider();

  // Product grids
  loadMoreGridItems();

  // Quantity selector on cart page
  updateQuantity();

  // Misc
  imagesInRichtext();
  insertImage();
  initMarquees();

};



const selectors = {

  // Body
  body                       : document.querySelector('body'),

  // Announcement
  announcement               : document.querySelector('#announcement'),
  announcementCTA            : document.querySelector('#announcementCTA'),

  // Header
  mainHeader                 : document.querySelector('#main-header'),
  itemsToSwap                : document.querySelectorAll('.c-u-later'),

  // Navigation
  burger                     : document.querySelector('#burger'),

  // Accordions
  accordions                 : document.querySelectorAll('.has-accordion'),

  // Slider
  stageSlider                : document.querySelector('.stage-slider ol'),
  thumbSlider                : document.querySelector('.thumb-slider > ol'),
  thumbNavSlider             : document.querySelector('.thumb-slider nav ol'),
  flexSliders                : document.querySelectorAll('.flex-slider ol'),

  // Load more grid items
  loadMoreGridItems          : document.querySelectorAll('.grid.with-load-more-closing li'),
  loadMoreCTA                : document.querySelector('#load-more'),

  // Add image ratio classes in richtext
  imagesInRichtext           : document.querySelectorAll('.richtext img'),
  
  // Add image ratio classes in richtext
  quantitySelectors          : document.querySelectorAll('.quantity-selector'),

  // Add image to BSS login page
  bssContainer               : document.querySelector('#BsscommercePasswordForm'),

};


getHash = () => {
  return window.location.hash;
};


hideAnnouncement = () => {
  if (selectors.announcement) {
    if (sessionStorage.getItem('announcement') === "hidden") {
      selectors.announcement.remove();
    }
    
    selectors.announcementCTA.addEventListener('click', () => {
      sessionStorage.setItem('announcement', 'hidden');
      selectors.announcement.remove();
    });
  }
};


swapHeaderItems = () => {

  const headerOffset = selectors.mainHeader.offsetTop;

  window.addEventListener('scroll', () => {

    selectors.itemsToSwap.forEach((itemToSwap) => {
      if (window.scrollY > headerOffset + 100) {
        itemToSwap.style.opacity = 1;
      } else {
        itemToSwap.style.opacity = 0;
      }
    })

  });

};


mobileDropdowns = () => {

  selectors.burger.addEventListener('click', (event) => {
    event.target.nextElementSibling.classList.toggle('block');
    event.target.classList.toggle('burger-close');
  })

};


toggleAccordion = () => {

  selectors.accordions.forEach((accordion) => {
    accordion.querySelector('.cta').addEventListener('click', (event) => {
      event.target.classList.toggle('active');
      event.target.parentElement.classList.toggle('active');
    })
  })

};


stageSlider = () => {

  if (selectors.stageSlider) {

    const
      titlePlaceholder = document.querySelector('.stage-slider #titlePlaceholder'),
      ctaPlaceholder = document.querySelector('.stage-slider #ctaPlaceholder'),
      prevButton = document.querySelector('.stage-slider .slider-buttons .prev'),
      nextButton = document.querySelector('.stage-slider .slider-buttons .next');

    let flkty = new Flickity( selectors.stageSlider, {
      wrapAround: true,
      pageDots: false,
      imagesLoaded: true,
      arrowShape: "M50.0038513,1.5063506e-12 L55.1613893,5.16524059 L10.323,49.936 L55.1613893,94.8424563 L49.9961544,100 L1.20792265e-13,49.9292888 L5.16523486,44.7717451 L50.0038513,1.5063506e-12 Z",
      selectedAttraction: 0.15,
      friction: 0.85,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false,
      accessibility: false,
      prevNextButtons: false,
      
      on: {
        ready: function() {
          const
            initialElement = this.selectedElement,
            initialTitle = initialElement.getAttribute('data-title'),
            initialURL = initialElement.getAttribute('data-url');
    
          titlePlaceholder.innerHTML = initialTitle;
          ctaPlaceholder.href = initialURL;
        },
        change: function() {
          const
            currentElement = this.selectedElement,
            currentTitle = currentElement.getAttribute('data-title'),
            currentURL = currentElement.getAttribute('data-url');
    
          titlePlaceholder.innerHTML = currentTitle;
          ctaPlaceholder.href = currentURL;
        }
      }
    });

    if ( matchMedia('screen and (max-width: 900px)').matches ) {
      flkty.stopPlayer();
    }
    window.addEventListener('resize', () => {
      if ( matchMedia('screen and (max-width: 900px)').matches ) {
        flkty.stopPlayer();
      } else {
        flkty.playPlayer();
      }
    })

    prevButton.addEventListener('click', () => {
      flkty.previous(true);
    });
    
    nextButton.addEventListener('click', () => {
      flkty.next(true);
    });

  }
  
};


thumbSlider = () => {

  if (selectors.thumbSlider) {

    let flkty = new Flickity( selectors.thumbSlider, {
      wrapAround: true,
      pageDots: false,
      imagesLoaded: true,
      arrowShape: "M50.0038513,1.5063506e-12 L55.1613893,5.16524059 L10.323,49.936 L55.1613893,94.8424563 L49.9961544,100 L1.20792265e-13,49.9292888 L5.16523486,44.7717451 L50.0038513,1.5063506e-12 Z",
      selectedAttraction: 0.15,
      friction: 0.85,
      accessibility: false,
      prevNextButtons: false
    });

    if (selectors.thumbNavSlider) {

      let flktyNav = new Flickity( selectors.thumbNavSlider, {
        asNavFor: selectors.thumbSlider,
        contain: true,
        cellAlign: 'left',
        pageDots: false,
        imagesLoaded: true,
        selectedAttraction: 0.15,
        friction: 0.85,
        accessibility: false,
        prevNextButtons: false
      });

      const
        prevButton = document.querySelector('.thumb-slider .slider-btn.prev'),
        nextButton = document.querySelector('.thumb-slider .slider-btn.next');

      if( prevButton ) {
        prevButton.addEventListener('click', () => {
          flktyNav.previous();
        });
      }

      if( nextButton ) {
        nextButton.addEventListener('click', () => {
          flktyNav.next();
        });
      }

    }

  }
  
};


responsiveSlider = () => {

  if (selectors.flexSliders) {

    selectors.flexSliders.forEach((flexSlider) => {
    
      let responsiveSlider;
    
      if(matchMedia('screen and (max-width: 900px)').matches) {
        responsiveSlider = new Flickity(flexSlider, {
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          imagesLoaded: true,
          selectedAttraction: 0.15,
          friction: 0.85
        });
      }
    
      window.addEventListener('resize', () => {
        if(matchMedia('screen and (max-width: 900px)').matches) {
          responsiveSlider = new Flickity(flexSlider, {
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            imagesLoaded: true,
            selectedAttraction: 0.15,
            friction: 0.85
          });
        } else {
          if (responsiveSlider) {
            responsiveSlider.destroy();
          }
        }
      });
    
    });

  }

};


loadMoreGridItems = () => {

  let gridItemsToShow;
  
  if (document.querySelector('.grid.with-load-more-closing .grid-heading')) {
    gridItemsToShow = document.querySelectorAll('.grid.with-load-more-closing li:nth-child(-n+21)');
  } else {
    gridItemsToShow = document.querySelectorAll('.grid.with-load-more-closing li:nth-child(-n+22)');
  }

  if (gridItemsToShow.length > 0) {

    gridItemsToShow.forEach((gridItemToShow) => {
      gridItemToShow.classList.add('block');
    });

    selectors.loadMoreCTA.addEventListener('click', (event) => {
      
      let
        allVisible = Array.from( document.querySelectorAll('.grid.with-load-more-closing ol li.grid-item.block') ),
        lastVisible = allVisible.indexOf( allVisible[allVisible.length -1] ),
        amountOfNextItems;

      if (document.querySelector('.grid.with-load-more-closing .grid-heading')) {
        amountOfNextItems = 21;
      } else {
        amountOfNextItems = 20;
      }

      nextItemsToShow = document.querySelectorAll( `.grid.with-load-more-closing ol li.grid-item:nth-child( n+${lastVisible} ):nth-child( -n+${lastVisible + amountOfNextItems + 1} )` );
      nextItemsToShow.forEach((nextItemToShow) => {
        nextItemToShow.classList.add('block');
      })

    })

  }

};


imagesInRichtext = () => {
  if (selectors.imagesInRichtext.length > 0) {

    selectors.imagesInRichtext.forEach( ( imageInRichtext ) => {

      const imageCombo = imageInRichtext.closest( '.image-combination' );

      // If images are part of the image combination shortcode
      if ( Boolean( imageCombo ) ) {
        const
          thisImages = imageCombo.querySelectorAll( 'img' ),
          thisCaptions = imageCombo.querySelectorAll( 'figcaption' );
        
        // Add captions
        thisImages.forEach( ( image, index ) => {
          if ( image.getAttribute( "alt" ) !== "" ) {
            thisCaptions[index].innerText = image.getAttribute( "alt" );
          }
        } );
      } else {
        let 
          newImg = imageInRichtext.cloneNode(false),
          fig = document.createElement('figure'),
          cap = document.createElement('figcaption');

        // Add captions
        fig.appendChild(newImg);
        
        if (newImg.getAttribute('alt') != '') {
          cap.innerText = newImg.getAttribute('alt');
          cap.classList.add('light-text');
          cap.classList.add('text-t2');
          fig.appendChild(cap);
        }

        // Add sizing classes
        const img = document.createElement( 'img' );
        img.addEventListener( "load", () => {
          if (imageInRichtext.width / imageInRichtext.height < 1) {
            fig.classList.add('portrait');
          } else if (imageInRichtext.width / imageInRichtext.height == 1) {
            fig.classList.add('square');
          } else {
            fig.classList.add('landscape');
          }
        } );
        img.setAttribute( "src", imageInRichtext.getAttribute( "src" ) );
        
        imageInRichtext.parentNode.replaceChild(fig, imageInRichtext);
      }
    } );

  }
}


updateQuantity = () => {
  
  if ( document.body.classList.contains('template-cart') || document.body.classList.contains('template-product') ) {

    selectors.quantitySelectors.forEach((quantitySelector) => {
  
      const 
        input = quantitySelector.querySelector('input'),
        decreaser = quantitySelector.querySelector('.decrease'),
        increaser = quantitySelector.querySelector('.increase'),
        max = input.getAttribute('max');
  
      decreaser.addEventListener('click', () => {
        if (parseInt(input.value) > 1) {
          input.value = parseInt(input.value) - 1;
        }
      });
  
      increaser.addEventListener('click', () => {
        if ( parseInt(input.value) < max ) {
          input.value = parseInt(input.value) + 1;
        }
      });

      ['blur','change'].forEach( evt => 
        input.addEventListener(evt, () => {
          if (input.value < 1) {
            input.value = 1;
          }
          input.value = Math.ceil(input.value / 1) * 1
        })
      );
    });

  }

};


insertImage = () => {

  if ( selectors.bssContainer ) {

    const
      figure = document.createElement( 'figure' ),
      img = document.createElement( 'img' );

    selectors.bssContainer.appendChild( figure );
    
    img.src='https://webstorejapan.artek.fi/cdn/shop/files/5807648_Vitra_Campus_Factory_Sale_2021_253__v_fullbleed_1440x_b3db8862-c54a-44ff-8806-7be46a42c7de.jpg?v=3934183541610598634';
    img.onload = () => {
      figure.appendChild( img );
    }
    
  }

};




/*
  Money Format
*/

if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
};




document.addEventListener('DOMContentLoaded', init);